import { defineMessages } from "react-intl";

/**
 * Tooltip / detail explainer copy keyed by TooltipId / DetailId.
 * Bindings map these to DS PriceLineItem tooltip/modal props (no onPress).
 */
export const tooltipTitleMessages = defineMessages({
  FoodDrinkMinimum: {
    defaultMessage: "Food and drink",
  },
  AddOnsTotal: {
    defaultMessage: "Add-on details",
  },
  ProcessingFee: {
    defaultMessage: "Processing fee",
  },
  CleaningFee: {
    defaultMessage: "Cleaning fee",
  },
  SplitPaymentFee: {
    defaultMessage: "Pay part now, part later fee",
  },
  HostFee: {
    defaultMessage: "Peerspace reservation fee",
  },
  EarningsSubtotal: {
    defaultMessage: "Earnings subtotal",
  },
  DiyHostFee: {
    defaultMessage: "Service fee",
  },
  FsvHostFee: {
    defaultMessage: "Peerspace reservation fee",
  },
  StaffGratuity: {
    defaultMessage: "Staff gratuity",
  },
  GuestVatTaxes: {
    defaultMessage: "Taxes",
  },
  FsvHostVatTaxes: {
    defaultMessage: "Taxes",
  },
  DiyHostVatTaxes: {
    defaultMessage: "Taxes",
  },
  DiySpaceRental: {
    defaultMessage: "Space rental",
  },
});

export const tooltipContentMessages = defineMessages({
  FoodDrinkMinimum: {
    defaultMessage:
      "During your event, food and beverage orders will go towards the venue's minimum spend.",
  },
  AddOnsTotal: {
    defaultMessage:
      "Extras the venue offers on top of the space rental, such as equipment, staffing, or services.",
  },
  ProcessingFee: {
    defaultMessage:
      "This covers costs that allow Peerspace to complete your transaction and provide support for your booking.",
  },
  CleaningFee: {
    defaultMessage: "A one-time fee charged by the host to clean the space.",
  },
  SplitPaymentFee: {
    defaultMessage:
      "A fee for splitting your payment into two charges instead of paying in full today.",
  },
  HostFee: {
    defaultMessage:
      "Peerspace's fee for providing the platform, payment processing, and support for your booking.",
  },
  EarningsSubtotal: {
    defaultMessage:
      "The earnings subtotal excludes the processing fee and applicable taxes, which are paid by the guest. Your Peerspace reservation fee is deducted from this amount.",
  },
  /**
   * DIY Section 2 host fee. "Learn more" is plain text here; web/mobile
   * bindings may turn it into a support-article link
   * (https://support.peerspace.com/en/articles/10119442-what-is-the-peerspace-service-fee).
   */
  DiyHostFee: {
    defaultMessage:
      "The service fee helps cover promotion of your space, insurance coverage, and booking support provided by Peerspace. Learn more",
  },
  FsvHostFee: {
    defaultMessage:
      "The reservation fee helps cover promotion of your space, insurance coverage, and booking support provided by Peerspace.",
  },
  StaffGratuity: {
    defaultMessage:
      "A tip for the venue's staff. The percentage is set by the venue.",
  },
  GuestVatTaxes: {
    defaultMessage:
      "VAT charged on the Processing fee. Other listed prices already include VAT.",
  },
  FsvHostVatTaxes: {
    defaultMessage:
      "VAT charged on the Peerspace reservation fee. Other listed prices already include VAT.",
  },
  DiyHostVatTaxes: {
    defaultMessage:
      "VAT charged on the Service fee. Other listed prices already include VAT.",
  },
  DiySpaceRental: {
    defaultMessage:
      "This is calculated from the listing's hourly rates, attendee pricing, and booking duration.",
  },
});

/**
 * Link label copy appended to a tooltip's explainer text. Keyed by
 * `TooltipId`; only tooltips with a follow-up link have an entry here. The
 * link is either a Help Center article (see `TOOLTIP_SUPPORT_ARTICLE_IDS`) or
 * an app-owned action the adapter supplies.
 */
export const tooltipLinkMessages = defineMessages({
  DiySpaceRental: {
    defaultMessage: "View pricing rules",
  },
  ProcessingFee: {
    defaultMessage: "Learn more",
  },
});
